<template>
  <v-card
    color="blue lighten-1"
    dark
  >
    <v-card-title class="title blue lighten-2">
      แผนการสอน
    </v-card-title>
    <v-card-text class="pa-0">
      <v-container grid-list-md text-xs-center fluid class="pa-2">
        <v-layout row wrap>
          <v-flex xs12 md2>
            <v-autocomplete
              :loading="loadingAcademicYear"
              :items="academicYearItems"
              label="ปี/ภาคการศึกษา"
              v-model="academicYear"
              item-value="id"
              item-text="yearSemester"
              outline
              hide-details
              :disabled="academicYearDisabled"
              @change=""
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md2>
            <v-select
              :items="courseTypeItems"
              label="หลักสูตร"
              v-model="courseType"
              item-value="value"
              item-text="text"
              :disabled="academicYear === null"
              outline
              hide-details
            ></v-select>
          </v-flex>
          <v-flex xs12 md6>
            <v-autocomplete
              :loading="loadingActiveCourses"
              :items="activeCourseItems"
              label="รายวิชา"
              v-model="activeCourse"
              item-value="id"
              item-text="subjectLabel"
              no-data-text="ไม่พบข้อมูล"
              return-object
              :disabled="activeCourseDisabled"
              outline
              hide-details
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md2>
            <v-autocomplete
              :loading="loadingSections"
              v-bind:items="sectionItems"
              label="กลุ่มใหญ่"
              v-model="section"
              item-value="id"
              item-text="name"
              no-data-text="ไม่พบข้อมูล"
              :disabled="sectionDisabled"
              outline
              hide-details
              ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      loadingAcademicYear: false,
      loadingActiveCourses: false,
      loadingSections: false,
      academicYear: null,
      activeCourse: null,
      courseType: null,
      section: null,
      courseTypeDisabled: true,
      academicYearItems: [],
      activeCourseItems: [],
      sectionItems: []
    }
  },
  computed: {
    ...mapGetters({
      courseTypeItems: 'activeCourse/courseTypeItems'
    }),
    academicYearDisabled () {
      return this.academicYearItems.length === 0
    },
    activeCourseDisabled () {
      return this.activeCourseItems.length === 0
    },
    sectionDisabled () {
      return this.sectionItems.length === 0 || this.activeCourse === null
    }
  },
  mounted () {
    this.fetchAcademicYears ()
  },
  methods: {
    fetchAcademicYears () {
      this.loadingAcademicYear = true
      this.$store.dispatch("academicYear/loadItems")
        .then((response) => {
          this.academicYearItems = response.data
          this.loadingAcademicYear = false
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingAcademicYear = false
        })
    },
    fetchActiveCourses () {
      this.loadingActiveCourses = true
      const params = {
        academicYear: this.academicYear,
        courseType: this.courseType
      }
      this.$store.dispatch('activeCourse/fetchItemsByAcademicYearAndCourseType', params)
        .then((response) => {
          this.loadingActiveCourses = false
          this.activeCourseItems = response.data
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingActiveCourses = false
        })
    },
    fecthSection () {
      this.loadingSections = true
      if(this.activeCourse.id) 
        this.$store.dispatch('section/fetchItemByActiveCourse', this.activeCourse.id)
        .then((response) => {
          this.loadingSections = false
          this.sectionItems = response.data
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingSections = false
        })
    }
  },
  watch: {
    academicYear (val) {
      if(val) {
        this.courseType = null
        this.activeCourse = null
        this.section = null
      }
    },
    activeCourse (val) {
      this.section = null
      if(val) {
        this.fecthSection ()
        // this.sectionDisabled = false
        this.subjectType = val.subject.subjectType
        if(this.subjectType === 'MANDATORY') {
          console.log("activeCourse val: ",  this.subjectType)
          this.dataTableView = 'data-table-l-g'
        }
        if(this.subjectType === 'ELECTIVE') {
          console.log("activeCourse val: ",  this.subjectType)
          this.dataTableView = 'data-table-combine'
        }
      } else {
        // this.sectionDisabled = true
      }
    },
    courseType (val) {
      this.activeCourse = null
      if(this.academicYear && val) {
        this.fetchActiveCourses()
        // this.activeCourseDisabled = false
      } else {
        //  this.activeCourseDisabled = true
      }
    },
    section (val) {
      // console.log('wacthing section...', val)
      const data = {
        dataTableView: this.dataTableView,
        section: this.section,
        sectionItems: this.sectionItems,
        subject: this.activeCourse.subject
      }
      if(val) {
        data.dataTableView = this.dataTableView
        data.section = this.section
        data.sectionItems = this.sectionItems
        data.subject = this.activeCourse.subject
      } else {
        data.dataTableView =  null
      }
      this.$emit('reload', data)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/course/coursePlan/filters/searchCoursePlan.vue